<template>
  <div>
    <v-row justify="center">
      <v-dialog max-width="680px" persistent v-model="dialogForm">
        <v-card>
          <v-toolbar color="grey lighten-4" flat>
            <v-toolbar-title class="text-h6">{{ formTitle }}</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-form @submit.prevent="submit" lazy-validation ref="form" v-model="valid">
            <v-card-text class="pb-0">
              <v-container fluid>
                <v-row>
                  <v-col class="py-0" md="6" cols="8">
                    <v-autocomplete
                      :error-messages="errors.mes"
                      :items="meses"
                      clearable
                      dense
                      hide-no-data
                      hide-selected
                      item-text="text"
                      item-value="value"
                      label="Mês"
                      outlined
                      placeholder="Selecione o mês"
                      v-model="formData.mes"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col class="py-0" md="6" cols="4">
                    <v-text-field
                      :error-messages="errors.ano"
                      counter="4"
                      class="pa-0"
                      dense
                      label="Ano"
                      outlined
                      v-mask="['####']"
                      placeholder="0000"
                      v-model.number="formData.ano"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" md="6" cols="12">
                    <v-text-field
                      :error-messages="errors.data_abertura"
                      class="pa-0"
                      dense
                      label="Data Abertura"
                      outlined
                      v-mask="['##/##/#### ##:##']"
                      placeholder="00/00/0000 00:00"
                      v-model="formData.data_abertura"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0" md="6" cols="12">
                    <v-text-field
                      :error-messages="errors.data_fechamento"
                      class="pa-0"
                      dense
                      label="Data Fechamento"
                      outlined
                      v-mask="['##/##/#### ##:##']"
                      placeholder="00/00/0000 00:00"
                      v-model="formData.data_fechamento"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn @click="toggleForm" color="red" dark depressed>
                <v-icon left small>mdi-close</v-icon>
                Fechar
              </v-btn>
              <v-btn
                :disabled="!valid"
                :loading="loadingSubmit"
                color="green"
                dark
                depressed
                type="submit"
              >
                <v-icon left small>mdi-send</v-icon>
                Salvar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { formataDataHoraEnGB, formataDataHoraPtBR } from '@/services/util/changeDate';
import toastMessage from '@/services/util/alertService';
import { mask } from 'vue-the-mask';

export default {
  name: 'CompetenciaModalForm',
  directives: {
    mask,
  },
  data: () => ({
    valid: true,
    meses: [
      { value: 1, text: 'Janeiro' },
      { value: 2, text: 'Fevereiro' },
      { value: 3, text: 'Março' },
      { value: 4, text: 'Abril' },
      { value: 5, text: 'Maio' },
      { value: 6, text: 'Junho' },
      { value: 7, text: 'Julho' },
      { value: 8, text: 'Agosto' },
      { value: 9, text: 'Setembro' },
      { value: 10, text: 'Outubro' },
      { value: 11, text: 'Novembro' },
      { value: 12, text: 'Dezembro' },
    ],
    formData: {
      id: '',
      mes: '',
      ano: '',
      data_abertura: '',
      data_fechamento: '',
    },
    formDataDefault: {
      id: '',
      mes: '',
      ano: '',
      data_abertura: '',
      data_fechamento: '',
    },
    errors: {
      mes: [],
      ano: [],
      data_abertura: [],
      data_fechamento: [],
    },
    loadingSubmit: false,
  }),
  computed: {
    ...mapState('competencia', ['dataIndex', 'data', 'dialogForm']),
    formTitle() {
      return this.dataIndex === -1 ? 'Adicionar Competência' : 'Editar Competência';
    },
  },
  methods: {
    ...mapActions('competencia', ['toggleForm', 'store', 'update', 'setDataIndex', 'clearData']),
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loadingSubmit = true;
        const actionHttp = this.dataIndex === -1
          ? this.store(this.getFormData()) : this.update(this.getFormData());
        actionHttp
          .then(() => {
            toastMessage.successSave('Competência salva com sucesso');
            this.$refs.form.reset();
          })
          .catch(({ response }) => {
            if (response.status === 422) {
              const { errors } = response.data;
              Object.entries(errors).forEach(([index, value]) => {
                this.errors[index].push(value.toString());
                toastMessage.errorValidation();
              });
            } else {
              toastMessage.errorSave();
            }
          })
          .finally(() => {
            this.loadingSubmit = false;
          });
      }
    },
    openDialog() {
      this.resetValidation();
      if (this.dataIndex > -1) {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          if (key === 'data_abertura' && this.data[key]) {
            this.formData[key] = formataDataHoraPtBR(String(this.data[key]));
          } else if (key === 'data_fechamento' && this.data[key]) {
            this.formData[key] = formataDataHoraPtBR(String(this.data[key]));
          } else {
            this.formData[key] = this.data[key];
          }
        });
      }
    },
    closeDialog() {
      setTimeout(() => {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.formDataDefault[key];
        });
        this.resetValidation();
        this.clearData();
        this.setDataIndex(-1);
      }, 300);
    },
    getFormData() {
      const obj = {};
      Object.entries(this.formDataDefault).forEach(([key]) => {
        if (key !== 'data_abertura' && key !== 'data_fechamento') {
          obj[key] = this.formData[key];
        } else if (this.formData[key]) {
          obj[key] = formataDataHoraEnGB(this.formData[key]);
        }
      });
      return obj;
    },
  },
  watch: {
    dialogForm(value) {
      if (value) {
        this.openDialog();
      } else {
        this.closeDialog();
      }
    },
    'formData.mes': function () {
      this.errors.mes = [];
    },
    'formData.ano': function () {
      this.errors.ano = [];
    },
    'formData.data_abertura': function () {
      this.errors.data_abertura = [];
    },
    'formData.data_fechamento': function () {
      this.errors.data_fechamento = [];
    },
  },
};
</script>

<style lang="scss">
.v-input__append-outer {
  .v-btn {
    margin-top: -5px;
  }
}
</style>
